import Form from "../../../../classes/Form";
import {route} from "../../../../functions/route";

const getDefaultState = () => {
	return {
		addingToCart: false,
		removingFromCart: false,
		cart: null,
		client: null,
		form: new Form({
			client: {
				email: "",
				profile: {
					name: {
						// title: "",
						first: "",
						last: "",
					},
					phone: "",
				},
			},
		}),
		routes: {
			cart: "cart",
			configureForm: "orders/create",
			configureCart: "cart/configure/:id",
			emptyCart: "cart/empty",
			addProduct: "cart/:id",
			deleteItem: "cart/:uuid",
		},
	};
};

const state = getDefaultState();

export default {
	namespaced: true,
	state,
	actions: {
		getCart({state}) {
			http().get(route(state.routes.cart)).then(response => {
				state.cart = response.data.data;
			});
		},
		addProductToCart({state}, product) {
			state.addingToCart = product.id;
			return new Promise((resolve, reject) => {
				http().patch(route(state.routes.addProduct, product)).then(response => {
					state.cart = response.data.data;
					resolve(response);
				}).catch(error => {
					reject(error);
				}).finally(() => {
					state.addingToCart = false;
				});
			});
		},
		deleteItem({state, dispatch, getters}, item) {
			state.removingFromCart = item.id;
			http().delete(route(state.routes.deleteItem, item)).then(response => {
				state.cart = response.data.data;
				if (!getters.cartHasItems) {
					dispatch("setClient");
				}
			}).finally(() => {
				state.removingFromCart = false;
			});
		},
		configureForm({state}) {
			http().get(route(state.routes.configureForm)).then(response => {
				state.form.setOptions(response.data.options);
				state.form.ready();
			});
		},
		configureCart({state, dispatch}, client) {
			http().get(route(state.routes.configureCart, client)).then(response => {
				state.cart = response.data.cart;
				dispatch("setClient", response.data.client);
			});
		},
		setClient({state}, client = null) {
			state.client = client;
		},
		emptyCart({state}) {
			http().patch(route(state.routes.emptyCart)).then(response => {
				state.cart = response.data.data;
			});
		},
	},
	getters: {
		cartItems: (state) => state.cart?.items || {},
		numberOfCartItems: (state, getters) => Object.keys(getters.cartItems).length,
		cartHasItems: (state, getters) => getters.numberOfCartItems > 0,
		validInstructionsForProduct: (state) => (item) => {
			if (!state.client) {
				return [];
			}
			return _.filter(state.client.instructions, instruction => {
				return instruction.service.id === item.model.service_id && instruction.service_variant === "purchase";
			});
		},
		isAddingToCart: (state) => (product) => state.addingToCart === product.id,
		primaryClientDetails: (state) => {
			return state.client || state.form.data.client;
		},
	},
	mutations: {
		RESET(state) {
			Object.assign(state, getDefaultState());
		},
	},
};
